<template>
  <div class="homepage">
    <FilterDatas 
      v-show="false"
      :collection="collection" 
      :mode="'prod'" 
      :model="['id', 'name', 'tags']"
      :setQuery="queryFromSidebar"
      @filteredData="filteredLogs"></FilterDatas>
    <el-dialog
      class="custom-modal-size"
      title="Filter"
      width="1100px"
      :visible.sync="getFilterModalVisible">
      <FilterDatas 
        :collection="collection" 
        :mode="'prod'" 
        :model="['id', 'name', 'tags']"
        :setQuery="queryFromSidebar"
        @filteredData="filteredLogs"></FilterDatas>
      <el-button @click="closeFilterModal">Fermer</el-button>
    </el-dialog>
    <!-- <ListOf :oflist="filteredCollection"></ListOf> -->
    <el-card class="custom-margin-bottom ">
      <TopBarMiniCard
        :title="$t('manufacturing_order')"
        :cardLoaded="collection.length"
        :val1="{key: $t('running'), value: String(stats.running)}"
        :val2="{key: $t('ended'), value: stats.finished}"
        :isLoaded="'isAllManufacturingOrdersLoaded'"
        @clickLoadMore="loadMoreData"
        @refresh="refreshData"
        @createNew="createNew"
      ></TopBarMiniCard>
    </el-card>
    <CardMini v-for="(mo, idx) in filteredCollection" :key="idx" :manufacturedOrder="mo" @closeForm="closeCreationForm"></CardMini>
    <!-- start Modal for Create OF form -->
    <el-dialog
      width="1200px"
      :visible.sync="dialogFormVisible"
      :modalAppendToBody="false">
        <CreateOfModal :key="dialogFormVisible" @closeForm="closeCreationForm"></CreateOfModal>
    </el-dialog>
    <!-- end Modal for Create OF form -->
  </div>
</template>

<script>
// import { opFabTable } from '../data/dynamoDBSimulation'
import DateTimeManipulation from '../mixins/DateTimeManipulation'
import CardMini from '@/components/CardMini.vue'
import TopBarMiniCard from '../components/TopBarMiniCard.vue'
import FilterDatas from '@/components/vuejs-components-collection/components-collection/FilterDatas.vue'
import CreateOfModal from '../components/of/CreateOfModal.vue'

export default {
  name: 'home',
  components: {
    FilterDatas,
    CardMini,
    TopBarMiniCard,
    CreateOfModal,
  },
  data() {
    return {
      filteredCollection: [],
      dialogFormVisible: false,
      stats: {
          finished: 0,
          running: 0,
          next: 0,
        }
    }
  },
  mounted() {
    if(this.$store.getters.operators.length === 0) {
      this.$store.dispatch('getOperators');
    }
    if(this.$store.getters.productionZones.length === 0) {
      this.$store.dispatch('getProductionZones');
    }
    if(this.$store.getters.manufacturingOrders.length === 0) {
      this.$store.dispatch('getManufacturingOrders');
    }
  },
  created() {
    this.stats = this.isRunningGlobalStat(this.collection);
    this.filteredCollection = this.collection;
  },
  watch: {
    collection: function() {
      this.stats = this.isRunningGlobalStat(this.collection);
      this.filteredCollection = this.collection;
    }
  },
  computed : {
    collection() {
      return this.$store.getters.manufacturingOrders
    },
    allLoaded() {
      return this.$store.getters.isAllManufacturingOrdersLoaded;
    },
    getFilterModalVisible: {
      get: function() {
        return this.$store.getters.getFilterModalVisible;
      },
      set: function() {
        return this.$store.dispatch('switchFilterModalVisible', false);
      }
    },
    queryFromSidebar() {
      return this.$store.getters.searchFavSelected;
    }
  },
  methods: {
    filteredLogs: function(event) {
      this.filteredCollection = event;
    },
    loadMoreData: function() {
      this.$store.dispatch('loadMoreManufacturingOrders');
    },
    refreshData: function() {
      this.$store.dispatch('refreshManufacturingOrders');
    },
    closeFilterModal: function() {
      this.$store.dispatch('switchFilterModalVisible');
    },
    createNew: function() {
      this.dialogFormVisible = true;
    },
    closeCreationForm: function() {
      this.dialogFormVisible = false;
    }
  },
  mixins: [DateTimeManipulation]
}
</script>

<style lang="css" scoped>
  .homepage {
    min-width: 950px;
  }

  .custom-modal-size {
    margin: auto;
  }

  .custom-margin-bottom {
    margin-bottom: 20px;
  }

  .el-dialog {
    width: 1100px !important;
  }

  .fixed-csv-btn {
    position: fixed;
    bottom: 10px;
    right: 10px;
  }

</style>
